export const apiKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweGJjNGRiNTBjZkFiY0I3OTFlOWE5MENENjUwNWI1NEI4NzljYjIxYzAiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTYyOTQwMzA2NDkxMSwibmFtZSI6IkFydEZvb2QifQ.99NeYMsijxvIOvmQnq8twQz-UbQR_UGUT-pwj91pJRw'
